import script from "./AccountSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./AccountSettingsModal.vue?vue&type=style&index=0&id=60badad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60badad0"]])

export default __exports__